import Backbone from '@polleverywhere/backbone'
import SSOProviders from '@toolkit/components/auth/sso/providers/index'
import Notification from '@toolkit/components/notification'

$(function () {
  const $placeholderElement = $('.oauth_google_signin_button')
  if (!$placeholderElement) { return }
  const sso = placeholderElToSSOProviders($placeholderElement)
  const cutlass = new PollEv.Service.Cutlass(new Backbone.Router())

  sso.on('view:action', (...args) => cutlass.app.trigger('view:action', ...args))

  $placeholderElement.append(
    sso.render().$el
  )

  if ($.meta('notification-message')) {
    const notification = new Notification({
      mode: 'banner',
      autoHideAfter: -1
    })
    $('.onboarding__signup-form__header').prepend(notification.render().$el)
    notification.$_toggleModifier(null, 'component-notification', 'inline')
    notification.$_element('actions').remove()
    const message = $.meta('notification-message')
    notification.notice(message)
  }
})

const placeholderElToSSOProviders = ($el) =>
  ssoProviders(
    placeholderElToSSOProviderOptions($el)
  )

const placeholderElToSSOProviderOptions = ($el) => ({
  redirectUrl: redirectUri(
    $el.attr('data-redirect')
  )
})

const ssoProviders = (options) => new SSOProviders({
  labelName: labelName(),
  providers: {
    google: {
      callbackFn: callbackFn(options)
    }
  }
})

const callbackFn = (options) => async (oauth2Redirect) => {
  oauth2Redirect.domain = domainUri()
  oauth2Redirect.platform = 'web'
  oauth2Redirect.prompt = 'select_account'
  oauth2Redirect.redirectUrl = options.redirectUrl
  oauth2Redirect.role = userRole()

  if (oauth2Redirect.errors.length) {
    return Promise.reject(new Error(oauth2Redirect.errors))
  }

  const query = userSourceParam() ? `&usrc=${userSourceParam()}` : ''
  window.location.href = oauth2Redirect.url + query
}

const userRole = () => $('#user_role').val()

const labelName = () => $('.oauth-label-name').data('labelName')

const domainUri = () => PollEv.env.get('api_url').toString()

const redirectUri = (postRedirectUri) => {
  const uri = PollEv.env.get('api_url').directory('/oauth2/callback')
  if (postRedirectUri) {
    uri.search({ redirect: postRedirectUri })
  }
  return uri.toString()
}

const userSourceParam = () => {
  if (!window.URLSearchParams) { return }
  const params = new URLSearchParams(window.location.search)
  return params.get('usrc')
}
